export const reduceMini = ({ dispatch }) => next => action => {
    if (action.type === 'DIRECT_LINE/CONNECT_FULFILLED') {
        setTimeout(() => {
            dispatch({
                type: 'WEB_CHAT/SEND_EVENT',
                payload: {
                    name: 'webchat/join',
                    value: {
                        language: 'pt-br'
                    }
                }
            });
        }, 1000);

    } else if (action.type === 'WEB_CHAT/SET_LANGUAGE') {
        action.payload.language = "pt-BR";
    }

    return next(action);
}